<template>
    <div class="memory" :class="[{ 'memory--active': active}, memoryTier]" @click="openMemory(data.id)">
        <div class="memory__icon" v-if="data.image === null">
            <i :class="data.icon"></i>
        </div>
        <div class="memory__image" :style="{ 'background-image': `url(${data.image})` }" v-if="data.image !== null"/>
        <div class="memory__wrapper">
            <div v-for="(person, i) in data.people" :key="i">
                <h4 class="title">{{person.name_of_loved}}</h4>
                <h4 class="subtitle">{{person.hebrew_name}}</h4>
                <h4 class="date">{{person.memorial_date}}</h4>
            </div>
            <div class="memory__content" :class="{ 'memory__content--active': active }" ref="memoryContent" style="height: 0;">
                <p>{{data.content}}</p>
            </div>
            <span class="memory__link">{{linkText}}</span>
        </div>
    </div>
</template>

<script>
  import {EventBus} from '../../eventbus';
  import i18n from '../../i18n';

  export default {
    name: 'Memory',

    props: {
      active: Boolean,
      data: Object,
      index: String
    },

    watch: {
      active: function(newVal, oldVal) {
        let memory = this.$refs.memoryContent;
        if (newVal) {
            memory.style.height = memory.scrollHeight + 'px';
        } else {
          memory.style.height = '0';
        }
      }
    },

    computed: {
      linkText: function () {
        return this.active ? i18n.t('close') : i18n.t('view-memory');
      },
      memoryTier: function () {
        switch (this.data.tier) {
          case 'BRASS':
            return 'memory-tier__brass';
          case 'COPPER':
            return 'memory-tier__copper';
          case 'SILVER':
            return 'memory-tier__silver';
          case 'GOLD':
            return 'memory-tier__gold';
          case 'ROSE GOLD':
            return 'memory-tier__rose-gold';
          case 'PLATINUM':
            return 'memory-tier__platinum';
          default:
            return '';
        }
      }
    },

    methods: {
      openMemory: function (i) {
        EventBus.$emit('active-memory', i);
      },
    }
  }
</script>
